import CommonLayout from "layouts/DashboardLayout";
import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import AddTraitForm from "../createTrait";
import { getTraitById } from "../../../redux/slices/traitSlice";

export default function AddTrait() {
  const dispatch = useDispatch();
  const { traitSlug = "" } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const roleTab = queryParams.get("roleTab");
  const platform = roleTab || "hemp";

  useEffect(() => {
    if (traitSlug) {
      dispatch(getTraitById({ slug: traitSlug, data: { userType: "admin" } }));
    }
  }, [traitSlug]);

  return (
    <CommonLayout>
      <AddTraitForm />
    </CommonLayout>
  );
}
